<script setup lang="ts">
import 'vue';
import { FhText } from '@fareharbor-com/beacon-vue';
import '@fareharbor-com/beacon-vue/icons';
import InfoCopy from '@/components/InfoCopy.vue';
import BaseFlexbox from '@/components/ui/BaseFlexbox/BaseFlexbox.vue';
import type { ItemListTableInstance } from './types';

interface ItemListDetailsProps {
  row: ItemListTableInstance;
}
defineProps<ItemListDetailsProps>();
</script>

<template>
  <BaseFlexbox direction="column" class="px-1 py-2">
    <FhText tag="p" variant="body-md" weight="medium">
      {{ row.name }}
    </FhText>
    <BaseFlexbox alignItems="center">
      <FhText
        weight="bold"
        tag="span"
        variant="body-sm"
        color="disabled"
        data-test-id="item-id"
      >
        ID: {{ row.itemId }}
      </FhText>
      <InfoCopy
        class="text-slate-400 font-normal ml-2 mt-1"
        :information="row.itemId.toString()"
      />
    </BaseFlexbox>
  </BaseFlexbox>
</template>
